import type { ComponentProps, Ref } from 'react';
import { ButtonControl } from './ButtonControl';

import type { ButtonHTMLAttributes } from 'react';
import { cx } from '../lib/cx';

export type StepperProps = ComponentProps<'ol'>;

export function Stepper({ className, ...props }: StepperProps) {
  return <ol className={cx('stepper', className)} {...props} />;
}

export interface StepperStepProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  isDone?: boolean;
  isCurrent?: boolean;
  isBlocked?: boolean;
}

export function StepperStep(
  { ref, isDone = false, isCurrent = false, isBlocked = false, className, type = 'button', children, ...rest }: StepperStepProps & { ref?: Ref<HTMLButtonElement> },
) {
  return (
    <li>
      <ButtonControl
        ref={ref}
        type={type}
        className={cx('stepper-step', isDone && 'is-done', isCurrent && 'is-current', className)}
        aria-current={isCurrent ? 'step' : undefined}
        aria-disabled={isBlocked ? true : undefined}
        {...rest}
      >
        {children}
      </ButtonControl>
    </li>
  );
}

export type ProgressBarProps = ComponentProps<'progress'>;

export function ProgressBar({ className, ...props }: ProgressBarProps) {
  return <progress className={cx('progress', className)} {...props} />;
}
